<template>
  <MasterLayout>
    <FundSubaccountModal :subAccountEmail="subAccountEmail" />
    <div class="fuelbalance_first_row">
      <div
        class="card_container"
        :style="{
          backgroundImage: `url(${cardBackgroundUrl})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right',
          backgroundSize: ' 136px',
        }"
      >
        <div class="row dashboard_card">
          <div class="col-lg-6 col-md-6">
            <p>{{ $t("text.subAccounts.title") }}</p>
          </div>
          <div class="col-lg-6 col-md-6 text-right">
            <img src="@/assets/img/Group568.png" height="40px" />
          </div>
        </div>
        <div class="dashboard_card_header_section text-center mt-4">
          <h6 class="dashboard_card_header">{{ subAccountCount }}</h6>
        </div>
      </div>
      <div
        class="fuelbalance_first_row_right_section mr-3 cus_bal"
        :style="[
          {
            backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.92), rgb(12, 4, 31 , 0.92)), url(${backgroundUrl})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          },
        ]"
      >
        <div class="transaction_buttons_div">
          <router-link :to="{ name: 'create_sub_account' }">
            <div class="fund_wallet_button_div mb-3 mr-3">
              <button class="fund_wallet_btn">
                {{ $t("text.subAccounts.createSubAccount") }}
                <img
                  src="@/assets/img/paper-plane.png"
                  width="30px"
                  class="ml-3"
                />
              </button>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <section class="section_2 mt-3">
      <div class="">
        <div class="section_2_table_section dropdown_parent">
          <div class="row">
            <div class="col-md-7">
              <div class="table_label_div">
                <div class="ml-3 mt-3">
                  <!-- <h3 class="section_2_table_title ml-3">Previous Bank Transactions </h3> -->
                </div>
              </div>
            </div>
            <div class="col-md-5 text-right">
              <div class="search_div mt-3 ml-5">
                <!-- <input type="search" placeholder="Search table list ..." /> -->
              </div>
            </div>
          </div>
          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="true"
            :allowSorting="true"
            :pageSettings="pageSettings"
            :toolbar="toolbar"
            :searchSettings="search"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick"
            :locale="usedLang"
          >
            <e-columns>
              <e-column width="40" field="index" headerText="#"></e-column>
              <e-column
                field="email"
                width="200"
                :headerText="$t('text.subAccounts.email')"
              ></e-column>
              <e-column
                field="firstName"
                width="150"
                :headerText="$t('text.subAccounts.firstName')"
              ></e-column>
              <e-column
                field="lastName"
                width="150"
                :headerText="$t('text.subAccounts.lastName')"
              ></e-column>
              <e-column
                field="phoneNumber"
                width="150"
                :headerText="$t('text.subAccounts.phoneNumber')"
              ></e-column>
              <e-column
                field="balance"
                format="N2"
                width="150"
                :headerText="$t('text.subAccounts.balance')"
              ></e-column>
              <!-- <e-column :template="buttonsTemplate" width=300></e-column> -->
              <!-- <e-column :template="deleButtonTemplate" width=150></e-column> -->
              <e-column :template="subaccounts_template" width="300"></e-column>
            </e-columns>
          </ejs-grid>
          <TableLoader :showLoader="showLoader" />
          <DropDown :details="details" />
        </div>
      </div>
    </section>
  </MasterLayout>
</template>
<script>
import Vue from "vue";
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/online-money-transfer-isometric-wallets-with-coins_107791-121.jpg";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import FundSubaccountModal from "@/components/modals/fundSubaccount.vue";
//import { ClickEventArgs } from '@syncfusion/ej2-vue-navigations';
import DropDown from "@/components/Templates/Dropdown/dropdown.vue";
import Temp from "@/components/Templates/subaccounts_temp.vue";

export default {
  title: "Sub Accounts:: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
    FundSubaccountModal,
    DropDown,
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      corpId: null,
      backgroundUrl,
      cardBackgroundUrl,
      subAccountCount: 0,
      walletTransactions: null,
      showLoader: false,
      totalTransactions: null,
      tableDataCount: 10,
      subAccounts: null,
      subAccountEmail: "",
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      details: {
        queryStrings: { id: "", userId: "" },
        info: [
          { name: "Voucher", link: "voucher" },
          { name: "Transactions", link: "previious_wallet_transaction" },
          { name: "Consumption", link: "fuel_consumption" },
        ],
        delete: {
          hasDelete: false,
          deleteName: "",
          name: "Delete",
          query: "userId",
        },
        // delete: { hasDelete: true, deleteName: 'deleteCompany', arg: 'companyId'}
      },
      subaccounts_template: function () {
        return {
          template: Temp,
        };
      },
      buttonsTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `
                                <div>
                                    <button class="view_details_btn" v-on:click="changeRoute('sub_account_details', data.email)">{{data.detailsButton}}</button> 
                                    <button class="view_details_btn" v-on:click="fundAccount(data)">Fund Account</button> 
                                </div>
                            `,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              fundAccount: function (data) {
                this.$eventHub.$emit("_fundAccount", data);
              },
              changeRoute: function (url, email) {
                this.$eventHub.$emit("gotoSub", url, email);
              },
            },
          }),
        };
      },
      deleButtonTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<button class="delete_btn" v-on:click="removeSubAccount(data.id)">{{data.deleteButton}}</button>',
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              removeSubAccount: function (id) {
                this.$eventHub.$emit("deleteSubAccount", id);
              },
            },
          }),
        };
      },
    };
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    this.getSubAccounts();
  },
  created() {
    this.$eventHub.$on("gotoSub", (url, email) => {
      this.changeRoute(url, email);
    });
    this.$eventHub.$on("_fundAccount", (data) => {
      this.openSubaccountModal(data);
    });
    this.$eventHub.$on(this.details.delete.deleteName, (id) => {
      this.deleteSubAccount(id);
    });
    this.$eventHub.$on("refreshSubAccountsList", () => {
      this.getSubAccounts();
    });
    this.$eventHub.$on("showExtraCompanyButtons", (data) => {
      this.details.queryStrings.id = data.id;
      this.details.queryStrings.userId = data.userId;
      this.details.queryStrings.email = data.email;
      this.details.queryStrings.balance = data.balance;
      const option = document.getElementById("myDropdown");
      option.classList.add("show");
      option.style.top = `${(
        62 * data.index +
        (150 - data.index * 2)
      ).toString()}px`;
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("deleteSubAccount");
    this.$eventHub.$off("gotoSub");
  },
  methods: {
    openSubaccountModal(data) {
      this.subAccountEmail = data.email;
      this.$modal.show("fundSubaccount");
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Sub-Accounts.pdf",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          this.$refs.dataGrid.getColumns()[6].visible = false;
          this.$refs.dataGrid.getColumns()[7].visible = false;
          break;
        case "Excel Export":
          let excelExportProperties = {
            fileName: "Sub-Accounts.xlsx",
          };
          this.$refs.dataGrid.excelExport(excelExportProperties);
          break;
      }

      setTimeout(() => {
        this.$refs.dataGrid.getColumns()[6].visible = true;
        this.$refs.dataGrid.getColumns()[7].visible = true;
      }, 1000);
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    changeRoute($newRoute, email) {
      this.$router.push({ name: $newRoute, query: { email: email } });
    },
    deleteSubAccount(id) {
      var deleteConfirm = confirm(this.$t("text.subAccounts.confirmDelete"));
      if (deleteConfirm) {
        let data = {
          id: id,
        };
        this.axios
          .post(
            `${configObject.apiBaseUrl}/SubAccount/Remove`,
            data,
            configObject.authConfig()
          )
          .then(() => {
            this.$toast.open({
              message: this.$t("text.subAccounts.successfullyDeleted"),
              type: "success",
              duration: 5000,
            });
            this.getSubAccounts();
          })
          .catch((error) => {
            this.$toast.open({
              message: error.response.data.message,
              type: "error",
              duration: 5000,
            });
          });
      }
    },
    getSubAccounts() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/SubAccounts`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          response.data.forEach((subAccount) => {
            index++;
            subAccount.index = index;
            subAccount.detailsButton = this.$t("text.subAccounts.details");
            subAccount.deleteButton = this.$t("text.actionButtons.delete");
          });
          this.showLoader = false;
          this.subAccountCount = response.data.length;
          grid.ej2Instances.setProperties({ dataSource: response.data });
          this.refreshGrid();
        })
        .catch((error) => {
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: "Network Error, Please Check Your Internet Connection",
              type: "error",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: "An Error Occured",
              type: "error",
              duration: 5000,
            });
          }
        });
    },
  },
};
</script>
